import React from 'react';
import styles from './index.css';
import { h5PageCount } from '../../../utils/h5PageCount';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from '../../wxLaunchApp';
import { wxShareTool } from '../../../utils/wxShareTool';
/**
 *
 * isVideoShare 是否是视频分享页
 * callAppConfig 拉活参数
 * videoActionConfig 点击视频统计
 * newsActionConfig 点击新闻统计
 * wxLaunchConfig 开放标签参数
 * brandPic 下浮层图片参数
 * activityUrl 跳转链接
 *
 **/
class pageBottomBrand extends React.PureComponent {
    constructor() {
        super(...arguments);
        /**
         * 渲染网页布局
         */
        this.defaultCallAppConfig = {
            client: 'newsApp',
            docType: 'awake',
            kind: 'share01',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8796',
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1453822808118',
            isJumpQQlink: false,
        };
        this.state = {
            isShowAppIcon: false,
        };
        this.androidAppIconHandle = () => {
            var _a;
            const UA = navigator.userAgent.toLocaleLowerCase();
            // @ts-ignore
            if (wxShareTool && UA.toLocaleLowerCase().match(/android/) && /micromessenger/i.test(UA)) {
                this.setState({
                    isShowAppIcon: false,
                });
            }
            else {
                this.setState({
                    isShowAppIcon: true,
                });
            }
            // @ts-ignore
            (_a = wxShareTool === null || wxShareTool === void 0 ? void 0 : wxShareTool.on) === null || _a === void 0 ? void 0 : _a.call(wxShareTool, 'showAppIcon', () => {
                this.setState({
                    isShowAppIcon: true,
                });
            });
            setTimeout(() => {
                if (!this.state.isShowAppIcon) {
                    this.setState({
                        isShowAppIcon: true,
                    });
                }
            }, 3000);
        };
        this.clickHandle = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
            const { callAppConfig = this.defaultCallAppConfig, actionConfig, isVideoShare, activityUrl } = this.props;
            if (actionConfig && actionConfig[0] && isSendCount) {
                actionConfig[0].datatype = isVideoShare ? 'vappsns_ex' : 'newsappsns';
                h5PageCount(actionConfig);
            }
            if (activityUrl) {
                location.href = activityUrl;
            }
            if (isCallApp && !activityUrl) {
                callAppConfig.isJumpQQlink = isJumpQQlink;
                callAppConfig.client = isVideoShare ? 'videoApp' : 'newsApp';
                // 视频走默认值
                if (isVideoShare) {
                    callAppConfig.downloadAd = '';
                    callAppConfig.download = '';
                }
                callApp(callAppConfig);
            }
        };
    }
    componentDidMount() {
        this.androidAppIconHandle();
    }
    render() {
        /**
         * 组件分发数据
         */
        const { callAppConfig = this.defaultCallAppConfig, isVideoShare, wxLaunchConfig, brandPic, activityUrl, } = this.props;
        const { isShowAppIcon } = this.state;
        const schemeLink = getSchemeLink(callAppConfig);
        const wxLaunchType = (wxLaunchConfig && wxLaunchConfig.wxLaunchType) || 'app';
        const wxLaunchSwitch = (wxLaunchConfig && wxLaunchConfig.wxLaunchSwitch) || false;
        const defaultBrandPicUrl = isVideoShare
            ? 'https://x0.ifengimg.com/ucms/2021_40/29E29EECB2649ADEC7D5B1230F4CCF1DCC901B2D_size52_w750_h112.png'
            : 'https://x0.ifengimg.com/ucms/2021_31/31A0009714B77C212C710F60DBC83CB0AF8AAD57_size20_w750_h112.png';
        const brandPicUrl = brandPic || defaultBrandPicUrl || '';
        return (React.createElement("div", { className: styles.pageBottomBrand, onClick: this.clickHandle.bind(this, true, false, true) },
            brandPic ? (React.createElement("img", { className: styles.pageBottomBrandPic, src: brandPicUrl })) : (React.createElement("div", { className: styles.pageBottomBox },
                React.createElement("span", { className: styles.pageBottomLogo }),
                isShowAppIcon && React.createElement("span", { className: styles.pageBottomButton }, "\u7ACB\u5373\u6253\u5F00"))),
            !isVideoShare && wxLaunchSwitch && !activityUrl && (React.createElement(WxLaunchApp, { launchType: wxLaunchType, launchAppClick: this.clickHandle.bind(this, true, false, false), schemeLink: schemeLink, launchAppFail: this.clickHandle.bind(this, false, true, true) }))));
    }
}
export default pageBottomBrand;
